exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n* {\n  padding: 0;\n  margin: 0;\n}\na {\n  text-decoration: none;\n  color: black;\n}\n#app {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font: 14px/1.5 Helvetica, sans-serif;\n  color: #333;\n}\n.weui-progress__inner-bar {\n  background: #d43c33 !important;\n}\n", ""]);

// exports
